/**
 * Toast type constants
 * Separated to avoid circular dependencies
 */
export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

/**
 * Default toast configuration
 */
export const DEFAULT_TOAST_OPTIONS = {
  duration: 5000,
  position: 'top-right',
  dismissible: true,
};
